import { BKJHorizontalRule } from '@awais4123/fillify-design-library';
import styled, { css } from 'styled-components';

export const ShiftModalWrapper = styled.div``;

export const SectionDivider = styled(BKJHorizontalRule)<{ margin?: string }>`
  ${({ margin }) => {
    if (margin)
      return css`
        margin: ${margin};
      `;
  }};
`;
